<script>
	// From Lucide
	import { Dot } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Dot class={iconClass} />
